import {Modal} from 'react-bootstrap'
import styles from './SaveAppPermissionModal.css'

class SaveAppPermissionModal extends React.Component {
  render () {
    const {show, message} = this.props
    return (<Modal onHide={() => {}} show={show} dialogClassName={`${styles.dialog} modal-dialog`}>
      <Modal.Header>
        <Modal.Title className={styles['title']}>Save App Permission</Modal.Title>
      </Modal.Header>
      <Modal.Body bsClass={`${styles.body} modal-body`}>
        <div>{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <span className='pull-right'>
          <button type='button' className='btn btn-primary' onClick={this.props.onConfirm}>
            OK
          </button>
        </span>
      </Modal.Footer>
    </Modal>)
  }
}

SaveAppPermissionModal.propTypes = {
  show: React.PropTypes.bool,
  onConfirm: React.PropTypes.func,
  message: React.PropTypes.string
}

SaveAppPermissionModal.defaultProps = {
  message: ''
}

export default SaveAppPermissionModal



// WEBPACK FOOTER //
// ./app/pages/Employees/Pin/SaveAppPermissionModal/SaveAppPermissionModal.js